// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"78f251c3","120":"9e76d111","493":"86e4d323","777":"bb296bfa","877":"adf55f8f","909":"494ffe6b"}[chunkId] + ".js";
};